module.exports = __webpack_public_path__ + "img/horizontal_4_6_7016.a74a1ab5.png";